/**CORE LIBRARIES IMPORT */
import { useEffect } from "react";

/**HOOKS IMPORT */
import useSiteSettings from "./useSiteSettings";

/**
 * Page title, plus the meta/Open Graph description, from portal Settings
 * (SEO title / SEO description). The edge Worker puts the same values into the
 * HTML for crawlers; this keeps them right during in-app navigation.
 */
export default function usePageTitle(title) {
  const { name, seoTitle, seoDescription } = useSiteSettings();
  useEffect(() => {
    document.title = title ? `${title} | ${name}` : seoTitle;
  }, [title, name, seoTitle]);
  useEffect(() => {
    for (const sel of ['meta[name="description"]', 'meta[property="og:description"]']) {
      document.querySelector(sel)?.setAttribute("content", seoDescription);
    }
  }, [seoDescription]);
}
